import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Element } from 'react-scroll';



import Navbar from './components/Navbar';
import About from './components/About';
import Program from './components/Program';
import Regulation from './components/Regulation';
import Location from './components/Location';
import Organization from './components/Organization';
import Sponsors from './components/Sponsors';
import Gallery from './components/Gallery';
import AfterContest from './components/AfterContest';
import Results from './components/Results';


import Footer from './components/Footer';
import './styles/App.css';
import Update from './components/Update';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Element name="about">
            <About />
          </Element>
          <Element name="program">
            <Program />
          </Element>
          <Element name="regulation">
            <Regulation />
          </Element>
          <Element name="organization">
            <Organization />
          </Element>
          <Element name="location">
            <Location />
          </Element>
          <Element name="gallery">
            <Gallery />
          </Element>
          <Element name="problems">
            <AfterContest />
          </Element>
          <Element name="results">
            <Results />
          </Element>
          <Sponsors />
        </main>
        <Update />
        <Footer />
      </div>
    </Router>
  );
}
export default App;
